(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4792],{

/***/ 63391:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 63391;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 11333:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/products/pdp",
      function () {
        return __webpack_require__(90526);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getServerSideProps": function() { return /* binding */ getServerSideProps; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67312);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9473);
/* harmony import */ var next_i18next_serverSideTranslations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55709);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52786);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7154);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48375);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34326);
/* harmony import */ var _components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50023);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29843);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88751);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(24899);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(44561);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(81169);
/* harmony import */ var _components_ProductDetail_v3_ProductDetail__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(95310);
/* harmony import */ var _components_PairsWellWith_PairsWellWith__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(75376);
/* harmony import */ var _components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(30534);
/* harmony import */ var _components_Review_v1_Review__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(16709);
/* harmony import */ var _components_ProductDetail_v3_ProductLandingTeasers_ProductExf__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(92762);
/* harmony import */ var _components_ProductDetail_v3_PDPLoader__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(2535);
/* harmony import */ var _components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(46760);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(10884);
































// const GlobalPageFooter = dynamic(
//   () => import("@/components/Shared/GlobalPage/GlobalPageFooter"),
//   { ssr: false }
// )
function ProductDetailsPage(param) {
    let { tmpData: data = {} , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , slug , tmpSkuId: skuId , type , pdpData , apiStatus: status , apiStatusText: statusText , initialImgAlt , initialImgUrl , initialImageFullUrl , isPart , siteName , locale  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_18__/* .selectAuthState */ ._9);
    const { pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_17__/* .selectGenericState */ .Px);
    const { isTeaserLoaded  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_19__/* .selectPdpState */ .BY);
    const [pageRedirect, setPageRedirect] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [priceSpiderKey, setPriceSpiderKey] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [priceSpiderLanguage, setPriceSpiderLanguage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [priceSpiderCountry, setPriceSpiderCountry] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)().then((config)=>setConfig(config));
        scrollToTop();
        const { ProductLocalCategory_s: productLocalCategory = "" , Product_Category: productCategory = "" , CustomerFacingSKU_s: skuID = "" , CustomerFacingBrand_s: siteName = ""  } = pdpData;
        window.needPdpdata = {
            productSubCatergory: productLocalCategory.toLowerCase() || productCategory.toLowerCase(),
            skuID,
            siteName: siteName.toLowerCase()
        };
        if (gbhDataLayerCustom) dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_17__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        return ()=>dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_17__/* .setGbhDataLayerCustom */ .ks)(""));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(config)) {
            const psKey = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.priceSpiderKey", "");
            if (psKey) {
                setPriceSpiderKey(psKey);
            }
            const psLanguage = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "internationalization.language", "");
            if (psLanguage) {
                setPriceSpiderLanguage(psLanguage);
            }
            const psCountry = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "internationalization.country", "");
            if (psCountry) {
                setPriceSpiderCountry(psCountry);
            }
        }
    }, [
        config
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,_hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (analyticsData) (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.removeAndCleanLink)(path));
        }
    }, [
        path
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
            (0,_components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_15__/* .getTeaserFragments */ .lX)(data, pdpData);
        }
    }, [
        accessToken,
        pdpData,
        pageIsInteractive,
        isTeaserLoaded
    ]);
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    const { language: metaLanguage = ""  } = data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_29___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preload",
                        href: "https://kohler.scene7.com/is/image/PAWEB/Template_PDP_PLP?$product_src=is{PAWEB/".concat(initialImgUrl, "}&$PDPMobile$"),
                        as: "image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preload",
                        href: "https://kohler.scene7.com/is/image/PAWEB/Template_PDP_PLP?$product_src=is{PAWEB/".concat(initialImgUrl, "}&$PDPDesktop$"),
                        as: "image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                psKey: priceSpiderKey,
                psCountry: priceSpiderCountry,
                psLanguage: priceSpiderLanguage,
                metaLanguage: metaLanguage,
                pdpData: pdpData,
                isPart: isPart,
                initialImageFullUrl: initialImageFullUrl,
                skuId: skuId,
                siteName: siteName
            }),
            header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                header: header,
                title: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaTitle_s,
                description: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaDescription_s,
                templateName: data === null || data === void 0 ? void 0 : data.templateName,
                globalScripting: globalScript
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_28___default()), {
                id: "zoomdatapdp",
                src: "https://s7d1.scene7.com/s7viewers/html5/js/ZoomViewer.js"
            }, "zoomdatapdp"),
            data && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(pdpData) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "min-vh-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    data: data,
                    count: 0,
                    productDetail: (data, slug, skuId, type)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductDetail__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            data: data,
                            pdpData: pdpData,
                            slug: slug,
                            skuId: skuId,
                            type: type,
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl
                        }),
                    productDetailFiller: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_PDPLoader__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                            initialImgAlt: initialImgAlt,
                            initialImgUrl: initialImgUrl,
                            pdpJson: data,
                            pdpData: pdpData,
                            skuId: skuId,
                            data: data
                        }),
                    pairsWellWith: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PairsWellWith_PairsWellWith__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            data: data,
                            skuId: skuId
                        }),
                    productAccordion: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            data: data
                        }),
                    review: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Review_v1_Review__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                            data: data
                        }),
                    productExf: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductLandingTeasers_ProductExf__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                            data: data
                        }),
                    slug: slug,
                    skuId: skuId,
                    type: type
                })
            }) : null,
            footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                footer: footer,
                footerScripting: footerScript
            }) : null
        ]
    });
}
/**
 *
 * @return {Object}
 */ async function getServerSideProps(param) {
    let { req , locale , query  } = param;
    const { url =""  } = req;
    const { leafcategory: slug = "" , skuId ="" , products =""  } = query;
    const isPart = products === "";
    var ref;
    const urlPathWithoutParams = (ref = url === null || url === void 0 ? void 0 : url.split("?")[0]) !== null && ref !== void 0 ? ref : "/".concat(locale);
    const { data: configData = {}  } = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_6__/* .aemAxiosInstance */ .Gb)({
        url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_5__.CORE_GLOBAL_CONFIG_URL, "?caConfig=true&path=/").concat(locale).concat(urlPathWithoutParams),
        method: "GET"
    });
    let profileName = isPart ? "profile_service_parts_PDP" : "profile_kohler_PDP";
    let collections = isPart ? "service_parts" : "kohler";
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(configData)) {
        const { general: { serviceParts ="service_parts" , siteName ="kohler"  } = {}  } = configData;
        const brandName = siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase();
        profileName = isPart ? "profile_".concat(serviceParts, "_PDP") : "profile_".concat(brandName, "_PDP");
        collections = isPart ? serviceParts : brandName;
    }
    let tmpSkuId = skuId;
    await (next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .i18n.reloadResources */ .ag.reloadResources());
    const isPreviewMode = req.cookies["aem-author-preview-mode"];
    var ref1;
    const ip = (ref1 = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.getClienIP)(req)) !== null && ref1 !== void 0 ? ref1 : "";
    const fullUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.generateCanonicalUrl)(url, locale, _constants__WEBPACK_IMPORTED_MODULE_5__.publicWebsiteUrl);
    let data;
    let apiStatus = 200;
    let apiStatusText = "";
    try {
        const response = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_6__/* .aemPreviewAxiosInstance */ .IT)({
            url: _constants__WEBPACK_IMPORTED_MODULE_5__.previewContentPrefix + "/".concat(locale).concat(_constants__WEBPACK_IMPORTED_MODULE_5__.PRODUCT_DATA_URL),
            method: "GET"
        }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_6__/* .aemApimAxiosInstance */ .v0)({
            url: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.buildUrlForAemApim)(_constants__WEBPACK_IMPORTED_MODULE_5__.PRODUCT_DATA_URL),
            method: "GET"
        });
        data = response === null || response === void 0 ? void 0 : response.data;
    } catch (error) {
        const { response: { status =500 , statusText =""  } = {}  } = error;
        if (status) apiStatus = status;
        if (statusText) apiStatusText = statusText;
    }
    const { globalScript ="" , footerScript ="" , pageComponentProperties ={} , data: rawAnalyticsData = "" , datalayerPageName ="" , eventPageType ="" , headerExpFrg ="" , footerExpFrg ="" , siteName: siteName1 = "" , topHeadScript =null  } = data;
    const analyticsData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.updateAnalyticPageUrl)(rawAnalyticsData, fullUrl);
    const { data: header  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_6__/* .aemPreviewAxiosInstance */ .IT)({
        url: "".concat(data.headerExpFrg ? data.headerExpFrg : _constants__WEBPACK_IMPORTED_MODULE_5__.headerUrl, ".model.json"),
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_6__/* .aemApimAxiosInstance */ .v0)({
        url: data.headerExpFrg ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.buildUrlForAemApim)("".concat(data.headerExpFrg, ".model.json")) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.buildUrlForAemApim)("".concat(_constants__WEBPACK_IMPORTED_MODULE_5__.headerUrl, ".model.json")),
        method: "get"
    });
    const { data: footer  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_6__/* .aemPreviewAxiosInstance */ .IT)({
        url: "".concat(data.footerExpFrg ? data.footerExpFrg : _constants__WEBPACK_IMPORTED_MODULE_5__.footerUrl, ".model.json"),
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_6__/* .aemApimAxiosInstance */ .v0)({
        url: data.footerExpFrg ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.buildUrlForAemApim)("".concat(data.footerExpFrg, ".model.json")) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.buildUrlForAemApim)("".concat(_constants__WEBPACK_IMPORTED_MODULE_5__.footerUrl, ".model.json")),
        method: "GET"
    });
    const pdpData = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_16__/* .getProductDetailsFromServer */ .MQ)(profileName, collections, slug);
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(pdpData) || !pdpData) {
        apiStatus = 404;
        apiStatusText = "Sorry. We could not find this page.";
        return {
            notFound: true
        };
    } else {
        if (!skuId && !isPart) {
            tmpSkuId = pdpData.masterSKU_s;
        }
    }
    let initialImgAlt = "";
    let initialImgUrl = "";
    let initialImageFullUrl = "";
    let tmpData = {};
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(pageComponentProperties)) {
        tmpData = pageComponentProperties;
    } else {
        tmpData = data;
    }
    if (tmpSkuId) {
        let variants = [];
        if (pdpData["variantList.sku_s"]) {
            variants = [
                pdpData["variantList.sku_s"]
            ];
        } else if (pdpData["variantList.sku_ss"]) {
            variants = pdpData["variantList.sku_ss"];
        }
        const variantImages = pdpData["productImages.labelWithUrl_s"] ? [
            pdpData["productImages.labelWithUrl_s"]
        ] : pdpData["productImages.labelWithUrl_ss"];
        let variantImageLabels = [];
        let variantImageURLs = [];
        if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
            const selVarImageUrls = [];
            const selVarImageLabels = [];
            variantImages.forEach((img)=>{
                const imgDetail = img.split("|");
                if (tmpSkuId === imgDetail[0]) {
                    var ref;
                    selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                    selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_5__.EMPTY_PIXEL);
                } else if (!variants.find((v)=>v === imgDetail[0])) {
                    var ref1;
                    variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                    variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_5__.EMPTY_PIXEL);
                }
            });
            variantImageLabels = [
                ...selVarImageLabels,
                ...variantImageLabels
            ];
            variantImageURLs = [
                ...selVarImageUrls,
                ...variantImageURLs
            ];
            if (variantImageURLs.length < 1) {
                variantImageLabels.push(tmpSkuId);
                variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_5__.EMPTY_PIXEL);
            }
        } else {
            variantImageLabels.push(tmpSkuId);
            variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_5__.EMPTY_PIXEL);
        }
        const assetIdArray = variantImageURLs ? variantImageURLs[0].split("PAWEB/") : [
            ""
        ];
        initialImgAlt = variantImageLabels[0];
        initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : "";
        var ref2;
        initialImageFullUrl = (ref2 = variantImageURLs.find((image)=>image.includes(initialImgUrl))) !== null && ref2 !== void 0 ? ref2 : "";
    }
    const gbhDataLayerCustom = {};
    if (datalayerPageName) {
        gbhDataLayerCustom.datalayerPageName = datalayerPageName;
    }
    if (eventPageType) {
        gbhDataLayerCustom.eventPageType = eventPageType;
    }
    if (data === null || data === void 0 ? void 0 : data.pageType) {
        gbhDataLayerCustom.pageType = data === null || data === void 0 ? void 0 : data.pageType;
    }
    if (data) tmpData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.filterBackEndJson)(tmpData);
    let headertmp;
    if (header) headertmp = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.filterBackEndJson)(header);
    let footertmp;
    if (footer) footertmp = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.filterBackEndJson)(footer);
    return {
        props: {
            ip,
            tmpData,
            headertmp,
            footertmp,
            globalScript,
            footerScript,
            analyticsData,
            gbhDataLayerCustom,
            topHeadScript,
            slug,
            tmpSkuId,
            pdpData,
            ...await (0,next_i18next_serverSideTranslations__WEBPACK_IMPORTED_MODULE_9__.serverSideTranslations)(locale, [
                "pdp"
            ]),
            apiStatus,
            apiStatusText,
            initialImgAlt,
            initialImgUrl,
            initialImageFullUrl,
            fullUrl,
            isPart,
            siteName: siteName1,
            locale
        }
    };
}
/* harmony default export */ __webpack_exports__["default"] = (ProductDetailsPage);


/***/ }),

/***/ 40816:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,2511,5709,3847,9717,4770,5576,228,5376,4789,9774,2888,179], function() { return __webpack_exec__(11333); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);